/**
 * Simplified TaskInput for framework
 * Only contains basic task fields: title and description
 */
export class TaskInput {
  title: string | undefined;
  description: string | undefined;
  type: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.title = payload.title;
      this.description = payload.description;
      this.type = payload.type;
    }
  }
}
